<template>
  <div class="grid">
    <div class="content--wrapper">
      <a-form layout="vertical" class="form" ref="formRef" :model="formState">
        <h1>Contenido de tus botones</h1>
        <p style="margin-bottom: 20px">
          Puedes añadir hasta 3 botones de un mismo tipo. 
          Si cambias el tipo mientras vas armando tus botones,
          estos se descartarán.
        </p>

        <CustomScrollbar class="scrollbar" height="430px">
          <a-form-item label="Tipos de botones" required name="button_type">
            <a-select
              :getPopupContainer="(triggerNode) => triggerNode.parentNode"
              v-model:value="formState.button_type"
              :options="templateTypeButtonOptions"
              placeholder="Seleccionar tipos de botones"
            />
            <small v-if="formState.button_type === WhatsappTemplateTypeButtons.CallToAction">
              Permite a los contactos llamar a un número de teléfono o visitar un sitio web.
            </small>
            <small v-if="formState.button_type === WhatsappTemplateTypeButtons.QuickReply">
              El contacto devolverá un mensaje de texto y se creará automáticamente un nuevo ticket en
              la plataforma.
            </small>
          </a-form-item>
          <div class="button--container" v-if="formState.button_type !== null">
            <div class="button--specific" v-for="(button, index) in formState.buttons" :key="index">
              <div class="button--head">
                <h3>{{ `Botón ${index + 1}` }}</h3>
                <a-button
                  type="link"
                  :class="`remove ${index === 0 ? 'hide' : ''}`"
                  @click="removeButton(index)"
                >
                  Eliminar botón
                </a-button>
              </div>
              <a-divider></a-divider>
              <a-form-item
                label="Tipo"
                required
                v-if="formState.button_type === WhatsappTemplateTypeButtons.CallToAction"
              >
                <a-select
                  :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                  v-model:value="button.type"
                  placeholder="Seleccionar tipo de botón"
                >
                  <a-select-option
                    v-for="option in templateTypeSpecificButtonOptions.filter((opt) => opt.value)"
                    :key="option.value"
                    :disabled="disableButtonSpecificType(option)"
                  >
                    {{ getOptionLabel(option, button) }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item
                label="Tipo"
                required
                v-if="formState.button_type === WhatsappTemplateTypeButtons.QuickReply"
                class="button--reply"
              >
                <a-input v-model:value="button.type" placeholder="Seleccionar tipo de botón" />
              </a-form-item>
              <!-- tipo de llamada -->
              <a-form-item
                label="Salida de llamada"
                required
                v-if="
                  (button.type === WhatsappTemplateTypeSpecificButtons.PhoneNumber ||
                  button.type === WhatsappTemplateTypeSpecificButtons.VoiceCall) &&
                  formState.button_type === WhatsappTemplateTypeButtons.CallToAction &&
                  channelsWhatsappMessageWithVoice.length > 0
                "
              >
                <a-select
                  :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                  v-model:value="button.callOutput"
                  placeholder="Seleccionar salida"
                >
                  <a-select-option
                    v-for="option in templateTypeCall.filter((opt) => opt.value)"
                    :key="option.value"
                    :disabled="disableButtonSpecificType(option)"
                  >
                    <span>
                      <icon-channel :type="option?.iconType" :width="16" />
                      {{ getOptionLabel(option, button) }}
                      <span v-if="option?.value === 'WHATSAPP_VOICE'">({{ associate }})</span>
                    </span>
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="Nombre del botón" required>
                <a-input
                  v-model:value="button.text"
                  :placeholder="`Botón ${index + 1}`"
                  :maxlength="25"
                />
                <small v-if="hasSpecialCharacters(button.text)">
                  No se admiten caracteres especiales
                </small>
              </a-form-item>
              <a-form-item
                label="URL"
                required
                v-if="
                  button.type === WhatsappTemplateTypeSpecificButtons.Url &&
                  formState.button_type === WhatsappTemplateTypeButtons.CallToAction
                "
              >
                <a-input v-model:value="button.url" placeholder="Escribir url" :maxlength="200" />
                <small v-if="button.url && !isValidUrl(button.url)">URL inválido</small>
              </a-form-item>
              <a-form-item
                v-if="
                  (button.callOutput === WhatsappTemplateTypeCall.CustomDestination ||
                  (button.type === WhatsappTemplateTypeSpecificButtons.PhoneNumber && channelsWhatsappMessageWithVoice.length === 0)) &&
                  formState.button_type === WhatsappTemplateTypeButtons.CallToAction
                "
                label="Teléfono de contacto"
                name="phone_number"
              >
                <a-row :gutter="16">
                  <a-col span="9">
                    <SelectorCountry @codePhone="button.code_phone = $event" :code="codePhone" />
                  </a-col>

                  <a-col span="15">
                    <a-input
                      v-model:value="button.phone"
                      placeholder="Número de celular"
                      :maxlength="codePhone === 1 ? 9 : 100"
                    />
                  </a-col>
                </a-row>
              </a-form-item>
            </div>
          </div>
        </CustomScrollbar>
        <a-button v-if="formState.buttons.length < 3 && formState.button_type !== null" type="link" @click="addButton">
          Agregar botón
        </a-button>
      </a-form>
    </div>
    <WhatsappTemplatePhone
      preview
      :content="content"
      :templateType="templateType"
      :buttons="formState.buttons"
      :buttonType="formState.button_type"
    />
  </div>
</template>

<script setup lang="ts">
import { reactive, inject, ref, watch, computed, onMounted } from "vue";
import {
  templateTypeButtonOptions,
  templateTypeSpecificButtonOptions,
  templateTypeCall,
} from "@/app/channels/utils/selectOptions";
import SelectorCountry from "@/app/shared/components/selectors/SelectorCountry.vue";
import {
  WhatsappTemplateTypeSpecificButtons,
  WhatsappTemplateTypeButtons,
  WhatsappTemplateTypeCall,
} from "@/app/channels/utils/enums.js";
import WhatsappTemplatePhone from "@/app/shared/components/organisms/WhatsappTemplatePhone.vue";
import { cloneDeep } from "lodash";
import { IButtonForm, IButton, ISpecificButton } from "@/@types/channels/buttons";
import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar.vue";
import IconChannel from "@/app/shared/components/icons/IconChannel.vue";
import { fetchAllChannelsCustomers } from "@/app/channels/services";
import { ChannelCustomer } from "@/@types/global";

const channelsWhatsappMessage = ref<ChannelCustomer[]>([]);

const props = defineProps({
  content: { type: String },
  associate: { type: String },
});

const channelsWhatsappMessageWithVoice = computed(() => (
  channelsWhatsappMessage.value.filter(
    (channel) => 
    channel?.data_parameters?.enable_voice === true &&
    channel?.data_parameters?.phone_number === props.associate
  )
));

const templateType = inject("templateType");
const codePhone = ref(1);
const valid = ref(false);
const formState: IButtonForm = reactive({
  button_type: null,
  buttons: [{ type: null, text: null, phone: null, code_phone: null, url: null, callOutput: null }],
});
const initialFormState = cloneDeep(formState.buttons);

const addButton = (): void => {
  if (formState.buttons.length < 3) {
    formState.buttons.push({
      type: null,
      text: null,
      phone: null,
      code_phone: null,
      url: null,
      callOutput: null,
    });
  }
};

const hasSpecialCharacters = (text: string | null) => {
  const notHaveSpecialChatsRegex = /^([A-Za-z0-9-%ñÑ&À-ú\s])+$/g;

  return text ? !notHaveSpecialChatsRegex.test(text) : false;
};

const removeButton = (index: number): void => {
  formState.buttons.splice(index, 1);
};

const isValidUrl = (url: string | null): boolean => {
  if (!url) return false;
  try {
    const parsed = new URL(url);
    return parsed.protocol === "http:" || parsed.protocol === "https:";
  } catch {
    return false;
  }
};

const resetForm = (): void => {
  formState.buttons = initialFormState;
  formState.buttons = cloneDeep(initialFormState);
};

const disableButtonSpecificType = (option: ISpecificButton): boolean => {
  const phoneNumber = WhatsappTemplateTypeSpecificButtons.PhoneNumber;
  const url = WhatsappTemplateTypeSpecificButtons.Url;

  const hasPhoneNumberButton = formState.buttons.some(
    (button: IButton) => button.type === phoneNumber
  );

  const urlButtonCount = formState.buttons.filter((button: IButton) => button.type === url).length;
  const hasTwoUrlButtons = urlButtonCount >= 2;

  if (option.value === phoneNumber && hasPhoneNumberButton) return true;
  if (option.value === url && hasTwoUrlButtons) return true;

  return false;
};

const areButtonsValid = () =>
  formState.buttons.every((button) => button.text && !hasSpecialCharacters(button.text));

const arePhoneNumbersValid = () =>
  formState.buttons.every(
    (button: IButton) =>
      button.type !== WhatsappTemplateTypeSpecificButtons.PhoneNumber ||
      button.callOutput === WhatsappTemplateTypeCall.WhatsappVoice ||
      (button.phone && button.code_phone)
  );

const areUrlsValid = () =>
  formState.buttons.every(
    (button: IButton) =>
      button.type !== WhatsappTemplateTypeSpecificButtons.Url || isValidUrl(button.url)
  );

const areCallOutputsValid = () =>
  formState.buttons.every((button: IButton) => {
    // Solo exigir callOutput si HAY salidas de voz disponibles
    const needsCallOutput =
      channelsWhatsappMessageWithVoice.value.length > 0 &&
      (button.type === WhatsappTemplateTypeSpecificButtons.PhoneNumber ||
       button.type === WhatsappTemplateTypeSpecificButtons.VoiceCall);

    return needsCallOutput ? !!button.callOutput : true;
  });

const getOptionLabel = (option: ISpecificButton, button: IButton) => {
  if (disableButtonSpecificType(option) && button.type !== option.value) {
    return option.label + option.info;
  }
  return option.label;
};

const emit = defineEmits(["active-button", "inactive-button"]);

onMounted(async () => {
  channelsWhatsappMessage.value = await fetchAllChannelsCustomers(3, null, 1);
  console.log('channelsWhatsappMessage.value',channelsWhatsappMessage.value)
});

watch(formState, () => {
  //Set Quick reply to button type
  formState.buttons.forEach((button: IButton) => {
    if (formState.button_type === WhatsappTemplateTypeButtons.QuickReply) {
      button.type = WhatsappTemplateTypeButtons.QuickReply;
    }
  });

  // Check if button_type and all buttons have type and text selected
  if (formState.button_type && areButtonsValid()) {
    // Check for additional conditions based on the button_type
    if (formState.button_type === WhatsappTemplateTypeButtons.CallToAction) {
      if (arePhoneNumbersValid() && areUrlsValid() && areCallOutputsValid()) {
        valid.value = true; 
        emit("active-button");
        return;
      }
    } else {
      valid.value = true; 
      emit("active-button");
      return;
    }
  }
  valid.value = false; 
  emit("inactive-button");
});

watch(
  () => formState.button_type,
  (newValue) => {
    if (newValue !== null && newValue !== undefined) {
      resetForm();
    }
  }
);

defineExpose({ formState, valid});
</script>

<style lang="sass" scoped>
h1
  margin: 0
.grid
  display: grid
  grid-template-columns: 1.1fr 0.9fr
  gap: 25px
.content
  min-height: 254px
  max-height: 254px

  &--wrapper
    padding-top: 8px
small
  font-size: 14px
  color: $gray-7
.button
  &--head
    display: flex
    justify-content: space-between
    .remove
      color: $red-6
    .hide
      display: none
  &--specific
    .ant-divider
      margin: 0 0 10px 0
    small
      color: $red-6
      font-size: $font-small
  &--reply
    display: none

.scrollbar
  padding-right: 10px
  min-height: 200px
:global(.scrollbar .ps__rail-x)
  display: none !important
</style>
